/* Paw Baby featured product: thumbnail gallery, quantity buttons, variant price. Add to cart is handled by paw-card.js. */
if (!customElements.get('paw-gallery')) {
  customElements.define(
    'paw-gallery',
    class PawGallery extends HTMLElement {
      connectedCallback() {
        this.thumbs = Array.from(this.querySelectorAll('.paw-feature__thumb'));
        this.slides = Array.from(this.querySelectorAll('.paw-feature__slide'));
        this.thumbs.forEach((thumb) => thumb.addEventListener('click', () => this.show(Number(thumb.dataset.index))));
      }

      show(index) {
        this.slides.forEach((slide) => (slide.hidden = Number(slide.dataset.index) !== index));
        this.thumbs.forEach((thumb) => {
          if (Number(thumb.dataset.index) === index) thumb.setAttribute('aria-current', 'true');
          else thumb.removeAttribute('aria-current');
        });
      }
    }
  );
}

(() => {
  if (window.pawFeatureInit) return;
  window.pawFeatureInit = true;

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.paw-feature [data-paw-qty]');
    if (!button) return;
    const input = button.parentElement.querySelector('input[name="quantity"]');
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(button.dataset.pawQty));
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('.paw-feature [data-paw-variant]');
    if (!select) return;
    const option = select.selectedOptions[0];
    const price = select.closest('.paw-feature').querySelector('[data-paw-price]');
    const now = price.querySelector('.paw-feature__now');
    const was = price.querySelector('.paw-feature__was');
    now.textContent = option.dataset.price;
    now.classList.toggle('paw-feature__now--sale', Boolean(option.dataset.compare));
    if (was) {
      was.hidden = !option.dataset.compare;
      if (option.dataset.compare) was.lastChild.textContent = option.dataset.compare;
    }
  });
})();
